import { render, staticRenderFns } from "./ConfigurationItem.vue?vue&type=template&id=6ca068b0&scoped=true&"
import script from "./ConfigurationItem.vue?vue&type=script&lang=js&"
export * from "./ConfigurationItem.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationItem.vue?vue&type=style&index=0&id=6ca068b0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca068b0",
  null
  
)

export default component.exports